<script setup lang="ts">
interface SeoFact {
    label: string
    value: string
}

defineProps<{
    title: string
    facts: SeoFact[]
}>()
</script>

<template>
    <section v-if="facts.length" class="seo-facts-block" :aria-label="title">
        <h2 class="seo-facts-title">{{ title }}</h2>
        <dl class="seo-facts-grid">
            <div v-for="fact in facts" :key="fact.label" class="seo-fact">
                <dt class="seo-fact-label">{{ fact.label }}</dt>
                <dd class="seo-fact-value">{{ fact.value }}</dd>
            </div>
        </dl>
    </section>
</template>

<style scoped lang="less">
.seo-facts-block {
    width: min(1200px, calc(100% - 32px));
    margin: 0 auto 120px;
    padding: 28px;
    text-align: left;
    background: #22242d;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
}

.seo-facts-title {
    margin: 0 0 22px;
    color: #fff;
    font-size: clamp(1.5rem, 3vw, 2.25rem);
    font-weight: 700;
    line-height: 1.2;
}

.seo-facts-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 24px;
    margin: 0;
}

.seo-fact {
    min-width: 0;
    padding: 18px;
    background: rgba(255, 255, 255, 0.04);
    border-radius: 12px;
}

.seo-fact-label {
    margin: 0 0 8px;
    color: #99f768;
    font-size: 0.95rem;
    font-weight: 700;
}

.seo-fact-value {
    margin: 0;
    color: #d4d4d8;
    font-size: 0.95rem;
    line-height: 1.65;
}

@media (max-width: 640px) {
    .seo-facts-block {
        width: calc(100% - 32px);
        margin-bottom: 72px;
        padding: 20px;
    }

    .seo-facts-grid {
        grid-template-columns: 1fr;
    }
}
</style>
